import { FC, useState } from 'react';

import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import { InputMask } from '@/components/ui/InputMask';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const INVOICE_POSTAL_CODE_NAME = 'invoice_postal_code';

interface Props {
  name?: string;
}

const InputInvoicePostalCode: FC<Props> = ({
  name = INVOICE_POSTAL_CODE_NAME,
}) => {
  const { i18n } = useLingui();
  const { control, trigger } = useFormContext();
  const [focused, setFocused] = useState(false);

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        validate: (v, form) =>
          form.is_company && !v?.trim() ? i18n.t('Uzupełnij to pole') : true,
      }}
      render={({
        field: { onBlur, onChange, value, ...field },
        fieldState: { error },
      }) => (
        <FormItem className="col-span-3 sm:col-span-1">
          <FormControl>
            <InputMask
              mask="00-000"
              inputMode="numeric"
              label={i18n.t('Kod pocztowy')}
              error={error?.message}
              success={!focused && !error && !!value}
              autoComplete="postal-code"
              value={value}
              onAccept={(v) => {
                onChange(v);
                if (error) trigger(name);
              }}
              onFocus={() => setFocused(true)}
              onBlur={() => {
                setFocused(false);
                onBlur();
              }}
              {...field}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default InputInvoicePostalCode;
